import {
  takeLatest, put, select, all, call,
} from 'redux-saga/effects';
import { get } from '@api/sharing';
import { autoRequest } from '@api/createRequestStore';
import { DASHBOARD_TYPE } from '@utils/constants';
import { message } from 'antd';
import { TRIGGER_ADD_TAB } from '@store/dashboards/tabs/types';
import { addNewSharedTab } from '../../sharedTabs/action';
import * as actions from './actions';
import * as types from './types';
import selector, { sharingResponseSelector } from './selectors';
import { filterShareddData } from '../base/utils';
import * as baseActions from '../base/actions';
import * as autoRequestTypes from '@api/createRequestStore/types';
import { fetchSPIThresholds } from '@store/overviewDashboard/spiThresholds/actions';

function* afterRequest() {
  const { state } = yield select(sharingResponseSelector);
  if (!state) {
    return;
  }
  const { ovbStore } = state;

  const { payload } = yield select(selector);

  try {
    const {
      common,
    } = state;

    const { selectedCustomerId } = common;

    const filteredState = filterShareddData(ovbStore);
    yield put(baseActions.updateBase(filteredState));
    yield put(fetchSPIThresholds());

    yield all([
      put(
        addNewSharedTab(
          {
            id: payload,
            state: filteredState,
            type: DASHBOARD_TYPE.OVB,
          },
          selectedCustomerId,
        ),
      ),
      put({
        type: TRIGGER_ADD_TAB,
        payload: {
          config:  {base: filteredState} ,
          dashboardTypeId: DASHBOARD_TYPE.OVB,
          unsaved: true,
          id: payload,
          name: `Overview ${payload}`,
          isSharing: true,
        },
      }),
    ]);
  } catch (error) {
    console.error(error);
    throw error;
  }
}

function* initRequest() {
  yield put(actions.initRequest());
}

function* fetching(action ) {
  try {
    // fetching status to be updated in autorequest method. As it's used by multiple components
    // not including it in this change
    yield put({ type: `${types.SCOPE}${autoRequestTypes.FETCHING}` });
    yield autoRequest(get, types.SCOPE, action.id, afterRequest);
  } catch (error) {
    yield call(message.error, error.message || 'Unknown error.');
    throw error;
  }
}

function* watchInitRequest() {
  yield takeLatest([types.INIT], initRequest);
}

function* watchFetching() {
  yield takeLatest([types.GET_SHARING], fetching);
}

export default [watchInitRequest, watchFetching];
